export const MAX_WORKFLOW_ASSET_BYTES = 20 * 1024 * 1024

const SPREADSHEET_CONTENT_TYPES = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv']

const PRESENTATION_CONTENT_TYPES = ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation']

const IMAGE_CONTENT_TYPES = ['image/gif', 'image/jpeg', 'image/png', 'image/webp']

const CONTENT_TYPES_BY_PROFILE: Record<string, string[]> = {
  pdf: ['application/pdf'],
  image: IMAGE_CONTENT_TYPES,
  spreadsheet: SPREADSHEET_CONTENT_TYPES,
  presentation: PRESENTATION_CONTENT_TYPES,
  document: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/json',
    'text/markdown',
    'text/plain',
    'image/jpeg',
    'image/png',
    ...SPREADSHEET_CONTENT_TYPES,
    ...PRESENTATION_CONTENT_TYPES,
  ],
}

export const contentTypesForProfile = (subType: string): string[] | undefined =>
  Object.hasOwn(CONTENT_TYPES_BY_PROFILE, subType) ? CONTENT_TYPES_BY_PROFILE[subType] : undefined

export const acceptForProfile = (subType: string): string | undefined => {
  const contentTypes = contentTypesForProfile(subType)
  return contentTypes ? [...contentTypes].sort().join(',') : undefined
}
